import { z } from "zod"

export type UOServers = 'Official UO' | 'UO Outlands' | 'UO Alive' | 'UO Unchained' | 'UO Forever' | 'UO Renaissance' | 'AA Siege Perilous' | 'UO Lost Lands' | 'UO 1998' | 'UO Second Age' | 'UO Gamers' | 'UO Shadow Age Reborn' | 'Insane UO' | 'UO Felucca' | 'UO Enigma' | 'UOG Demise'

export const availableUOServers: UOServers[] = ['Official UO', 'UO Outlands', 'UO Alive', 'UO Unchained', 'UO Forever', 'UO Renaissance', 'AA Siege Perilous', 'UO Lost Lands','UO 1998','UO Second Age','UO Gamers','UO Shadow Age Reborn','Insane UO','UO Felucca','UO Enigma','UOG Demise']

// export const serverSlugs: Record<UOServers, string> = {
//     'UO Outlands':  "uo-outlands",
//     'UO Alive': "uo-alive",
//     'UO Unchained': "uo-unchained",
// }

// server-imperial-shard
// server-uo-sagas

export const serverInfo = [
    {
        name: "UO Sagas",
        slug: "uo-sagas",
        website: "https://uosagas.com/",
        logo: "/images/logos/server-uo-sagas.png",
        shards: [
            'UO Sagas'
        ],
        establishedAt: new Date("May 17, 2025"),
        description: "Welcome to UO Sagas - a challenging free-to-play adventure crafted by veterans of Defiance UO. Experience a complete new world with classic feel but unique gameplay. Explore dangerous dungeons, defeat epic bosses, build wealth, and forge alliances in this fresh chapter of Ultima Online.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "AnimalTaming",
            "Archery",
            "ArmsLore",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Fencing",
            "Fishing",
            "Healing",
            "Herding",
            "Hiding",
            "Inscribe",
            "ItemID",
            "Lockpicking",
            "Lumberjacking",
            "Mace Fighting",
            "Magery",
            "Meditation",
            "Mining",
            "Musicianship",
            "Parry",
            "Peacemaking",
            "Poisoning",
            "Provocation",
            "RemoveTrap",
            "Resisting",
            "Skinning",
            "Snooping",
            "SpiritSpeak",
            "Stealing",
            "Stealth",
            "Swords",
            "Tactics",
            "Tailoring",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Wrestling",
        ]
    },
    {
        name: "Imperial Shard",
        slug: "imperial-shard",
        website: "https://imperialshard.com.br/",
        logo: "/images/logos/server-imperial-shard.png",
        shards: [
            'Imperial Shard'
        ],
        establishedAt: new Date("January 1, 2025"),
        description: "Imperial Shard is a free-to-play Brazilian Ultima Online server.",
    },
    {
        name: "Official UO",
        slug: "official-uo",
        website: "https://uo.com",
        logo: "/images/logos/server-uo-broadsword.png",
        shards: [
            'Oceania',
            'Sakura',
            'Mugen',
            'Wakoku',
            'Formosa',
            'Izumo',
            'Yamato',
            'Asuka',
            'Balhae',
            'Europa',
            'Drachenfels',
            'Legends',
            'Atlantic',
            'Lake Superior',
            'Great Lakes',
            'Chesapeake',
            'Catskills',
            'Siege Perilous',
            'Origin',
            'Pacific',
            'Sonoma',
            'Lake Austin',
            'Baja',
            'Napa Valley',
            'New Legacy',
            //'Test Center'
        ],
        establishedAt: new Date("September 24, 1997"),
        description: "To all of those for whom it's the first time you are hearing of Britannia, we bid you welcome, and to any of those who have visited in Ultima Online’s long history or who have seen Britannia through any of the other Ultima games, we bid you welcome home. There’s no place like it, or so we’re always told.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            "Necromancy",
            "Focus",
            "Chivalry",
            "Bushido",
            "Ninjitsu",
            "SpellWeaving",
            "Mysticism",
            "Imbuing",
            "Throwing",
        ]
    },
    {
        name: "UO Outlands",
        slug: "uo-outlands",
        shards: [
            'Outlands',
        ],
        website: "https://uooutlands.com",
        logo: "/images/logos/server-uo-outlands.png",
        establishedAt: new Date("October 1, 2018"),
        description: "UO Outlands is a free-to-play Ultima Online shard loosely set in the T2A era which launched in October of 2018. Our mission from the onset has been to create a version of Ultima Online which enhances every aspect of gameplay, creating a shard which we believe emulates how Ultima Online should have always been had it stayed the course.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Arcane",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            "Necromancy",
            "Focus",
            "Chivalry",
            // "Bushido",
            // "Ninjitsu",
            // "SpellWeaving",
        ]
    },
    {
        name: "UO Alive",
        slug: "uo-alive",
        shards: [
            'Alive',
        ],
        logo: "/images/logos/server-uo-alive.png",
        establishedAt: new Date("January 1, 2017"),
        website: "https://uoalive.com",
        description: "UO Alive is a free-to-play Ultima Online shard that launched in 2016. It is a custom map with custom content and a focus on PvE.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            "Necromancy",
            "Focus",
            "Chivalry",
            "Bushido",
            "Ninjitsu",
            "SpellWeaving",
            "Mysticism",
            "Imbuing",
            "Throwing",
        ]
    },
    {
        name: "UO Forever",
        slug: "uo-forever",
        shards: [
            'Forever',
            'Overdrive',
        ],
        establishedAt: new Date("January 18, 2013"),
        logo: "/images/logos/server-uo-forever.png",
        website: "https://uoforever.com",
        description: "On January 18th, 2013, Ultima Online Forever was launched providing players from around the globe a free shard that pays homage to the Renaissance era of the original Ultima Online with all of its nostalgia, while always building on and expanding the game to offer new and exclusive content.",
        skills: [
"Alchemy",
"Anatomy",
"AnimalLore",
"ItemID",
"ArmsLore",
"Parry",
"Begging",
"Blacksmith",
"Fletching",
"Peacemaking",
"Camping",
"Carpentry",
"Cartography",
"Cooking",
"DetectHidden",
"Discordance",
"EvalInt",
"Healing",
"Fishing",
"Forensics",
"Herding",
"Hiding",
"Provocation",
"Inscribe",
"Lockpicking",
"Magery",
"MagicResist",
"Tactics",
"Snooping",
"Musicianship",
"Poisoning",
"Archery",
"SpiritSpeak",
"Stealing",
"Tailoring",
"AnimalTaming",
"TasteID",
"Tinkering",
"Tracking",
"Veterinary",
"Swords",
"Macing",
"Fencing",
"Wrestling",
"Lumberjacking",
"Mining",
"Meditation",
"Stealth",
"RemoveTrap",
"Necromancy",
"Focus",
"Chivalry",
"Bushido",
"Ninjitsu",
"SpellWeaving",
"Mysticism",
"Imbuing",
"Throwing",
            
        ]
    },
    {
        name: "UO Unchained",
        slug: "uo-unchained",
        shards: [
            'Unchained',
        ],
        establishedAt: new Date("March 18, 2023"),
        logo: "/images/logos/server-uo-unchained.png",
        website: "https://play-uo.com",
        description: "UO Unchained is a free-to-play Ultima Online shard that launched in 2020. It is a custom map with custom content and a focus on PvE.",
        skills: [
            "Alchemy",
            "Anatomy",
            "Animal Lore",
            "Item Identification",
            "Arms Lore",
            "Parrying",
            "Scavenging",
            "Blacksmithing",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "Detecting Hidden",
            "Discordance",
            "Eval Intelligence",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscription",
            "Lock Picking",
            "Magery",
            "Resisting Spells",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "Spirit Speak",
            "Stealing",
            "Tailoring",
            "Animal Taming",
            "Taste Identification",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swordsmanship",
            "Mace Fighting",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "Remove Trap",
            "Necromancy",
            "Focus",
            "Chivalry",
            "Bushido",
            "Ninjitsu",
            "Spellweaving",
            "Mysticism",
            "Imbuing",
            "Throwing",
        ]
    },
    {
        name: "UO Renaissance",
        slug: "uo-renaissance",
        establishedAt: new Date("September 01, 2012"),
        shards: [
            'Renaissance',
        ],
        logo: "/images/logos/server-uo-renaissance.png",
        website: "https://uorenaissance.com/",
        description: "UO:Renaissance is an Ultima Online free-shard, based on Renaissance era mechanics, without the influences of Trammel. Designed and operated by passionate PvM and PvP experienced staff, that do not play here, this recreation aims to perfect what we all loved about Ultima Online before its decline. A highly immersive game with seemingly limitless possibilities coupled with risk vs reward, this world is what the players make of it. Offering an extensive crafting system with the best free shard economy, PvP mechanics with more templates than you'll have the time for and PvM with more challenge and data than ever before.  This is the shard to play on if you want to truly enjoy Ultima Online.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
    },
    {
        name: "Angel Island",
        slug: "uo-angel-island",
        shards: [
            'Angel Island 2016',
            'Angel Island 2024',
            'Siege Perilous 2024',
            //'AI Test Center 2016',
            //'Player Tribute',
        ],
        logo: "/images/logos/server-ai-siege-perilous.png",
        website: "https://game-master.net",
        description: "The launcher will install both Angel Island and Siege Perilous all at once. Both shards are available through the server listing once logged in to the game.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
    },
    {
        name: 'UO Lost Lands',
        slug: 'uo-lost-lands',
        shards: [
            'Lost Lands',
        ],
        logo: '/images/logos/server-lostlands.png',
        website: 'https://uolostlands.com',
        description: 'Set during The Second Age of Ultima Online - Lost Lands is an unrestricted, OSI accurate online game full of risk, reward, and endless adventure. Enjoy the freedom of customising your own skillset to become a powerful mage, merciless fighter, crafter, tamer, treasure hunter, or perhaps a dishonorable thief or murderer. Stake your claim of land and build yourself a home to live in, from small houses to grand castles in an open sandbox world.',
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
    },
    {
        name: 'UOG Demise',
        slug: 'uog-demise',
        establishedAt: new Date("September 01, 2004"),
        shards: [
            'Demise'
        ],
        logo: '/images/logos/server-uog-demise.png',
        website: 'https://www.uogdemise.com/',
        description: `Demise began its life in September '04 and, as part of the UOGamers family, quickly grew to a popular shard. Formerly the flagship development shard of the RunUO Software Team, last released publicly in 2013, it has since undergone a paradigm shift exceeding all expectations as a standalone shard.

        Over the years, Demise has built one of the strongest, most supportive gameplay communities, alongside an unparalleled level of reliability and uptime. With so much love and fondness for Demise, from both players and the staff team, the future looks bright!
        
        Demise strives to retain the core gameplay of a Mondain's Legacy era shard, with a few added extras. Come and explore the endless possibilities, from dungeon Doom to crafting to PvP to Peerless and much more! Join our community to keep up with the latest news, make new friends and you will no doubt feel right at home. With an established staff team and year-round events, entertainment is guaranteed!`
        
    },
    {
        name: 'UO Enigma',
        slug: 'uo-enigma',
        establishedAt: new Date("November 9, 2024"),
        shards: [
            'Enigma'
        ],
        logo: '/images/logos/server-uo-enigma.png',
        website: 'https://uo-enigma.com',
        description: `Why Play on UO Enigma?

        UO:Enigma is a true passion project, refined over years of dedication.
        Mid-sized, fully custom map with an exciting Felucca ruleset.
        Nostalgic, yet brimming with fresh and unique content.`
        
    },
    {
        name: 'UO Felucca',
        slug: 'uo-felucca',
        establishedAt: new Date("December 16, 2022"),
        shards: [
            'Felucca'
        ],
        logo: '/images/logos/server-uo-felucca.png',
        website: 'https://uofelucca.net/',
        description: `Explore the world of Felucca, a custom free-to-play Ultima Online shard that blends pre-AoS mechanics for exhilarating PvP with enhanced PvM and crafting experiences for additional custom content. What will you become? Forge your fantasy!`,
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
     },
     {
        name: 'Insane UO',
        slug: 'insane-uo',
        establishedAt: new Date("December 16, 2022"),
        shards: [
            'InsaneUO'
        ],
        logo: '/images/logos/server-insane-uo.png',
        website: 'https://insaneuo.com/',
        description: `Insane UO takes modern UO and makes it crazy! Crazy awesome, that is! Our focus is to get you up and running quickly so you can enjoy the content you love. And more than that, we want to reward you for doing the content you enjoy most, whether it’s Champion Spawns, Peerless bosses, Crafting, or just hunting monsters! While this is primarily a PvM/PvE server, consensual PvP is allowed via Guild wars and the arenas!`,
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
     },
     {
        name: 'UO Shadow Age Reborn',
        slug: 'uo-shadow-age-reborn',
        establishedAt: new Date("December 12, 2023"),
        shards: [
            'Shadow Age'
        ],
        logo: '/images/logos/server-shadow-age-reborn.png',
        website: 'https://shadowagereborn.com/',
        description: `A massively rebuilt Age of Shadows experience, UO Shadow Age returns once again!  Originally released 10 years ago and became one of the largest AOS freeshards out there. We've rebuilt and modernized the original Felucca landmass, including transparent water (including ocean), improved the looks of nearly all dungeons and many towns, built dozens of new POI's all over the overworld of Sosaria, removed some underused cities/land areas, and rebuilt old dungeons (like wrong, fire) entirely and enhanced old favorites (like ice and covetous) again.`,
        skills: [
"Alchemy",
"Anatomy",
"AnimalLore",
"ItemID",
"ArmsLore",
"Parry",
"Begging",
"Blacksmith",
"Fletching",
"Peacemaking",
"Camping",
"Carpentry",
"Cartography",
"Cooking",
"DetectHidden",
"Discordance",
"EvalInt",
"Healing",
"Fishing",
"Forensics",
"Herding",
"Hiding",
"Provocation",
"Inscribe",
"Lockpicking",
"Magery",
"MagicResist",
"Tactics",
"Snooping",
"Musicianship",
"Poisoning",
"Archery",
"SpiritSpeak",
"Stealing",
"Tailoring",
"AnimalTaming",
"TasteID",
"Tinkering",
"Tracking",
"Veterinary",
"Swords",
"Macing",
"Fencing",
"Wrestling",
"Lumberjacking",
"Mining",
"Meditation",
"Stealth",
"RemoveTrap",
"Necromancy",
"Focus",
"Chivalry",
"Bushido",
"Ninjitsu",
"SpellWeaving",
"Mysticism",
"Imbuing",
"Throwing",
            
        ]
     },
     {
        name: 'UO Gamers',
        slug: 'uo-gamers',
        establishedAt: new Date("Jan 1, 1999"),
        shards: [
            'UO Gamers'
        ],
        logo: '/images/logos/server-uo-gamers.png',
        website: 'https://uogamers.com/',
        description: `Launched in 1999, before RunUO existed, UOGamers has been the standard barer for Ultima Online servers. WIth a peak usercount of more than 15,000 online users, we are foundational to the Ultima Online community.`,
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
     },
     {
        name: 'UO Second Age',
        slug: 'uo-second-age',
        establishedAt: new Date("Jan 1, 2007"),
        shards: [
            'Second Age'
        ],
        logo: '/images/logos/server-uo-second-age.png',
        website: 'https://www.uosecondage.com/',
        description: `Founded in 2007, Second Age has established itself as the preeminent T2A era free shard in operation. With our mission being to provide an accurate representation of Ultima Online, the way it was in 1999, our staff does not endorse any particular style of play on Second Age`,
        skills: [
"Alchemy",
"Anatomy",
"AnimalLore",
"ItemID",
"ArmsLore",
"Parry",
"Begging",
"Blacksmith",
"Fletching",
"Peacemaking",
"Camping",
"Carpentry",
"Cartography",
"Cooking",
"DetectHidden",
"Discordance",
"EvalInt",
"Healing",
"Fishing",
"Forensics",
"Herding",
"Hiding",
"Provocation",
"Inscribe",
"Lockpicking",
"Magery",
"MagicResist",
"Tactics",
"Snooping",
"Musicianship",
"Poisoning",
"Archery",
"SpiritSpeak",
"Stealing",
"Tailoring",
"AnimalTaming",
"TasteID",
"Tinkering",
"Tracking",
"Veterinary",
"Swords",
"Macing",
"Fencing",
"Wrestling",
"Lumberjacking",
"Mining",
"Meditation",
"Stealth",
"RemoveTrap",

        ]
     },
     {
        name: 'UO 1998',
        slug: 'uo-1998',
        establishedAt: new Date("Jan 24, 2025"),
        shards: [
            'UO 1998'
        ],
        logo: '/images/logos/server-uo-1998.png',
        website: 'https://www.uo1998.com/',
        description: `UO: 1998 is a faithful recreation of the original Ultima Online experience, using the original 1.25.35 client from 1998. We've meticulously crafted a server that reflects the era-accurate gameplay based on code from the UO Demo, before the introduction of T2A.

        This is a museum of the original Ultima Online, untouched by modern changes. No modern clients or assistants will work here, offering a truly authentic experience for those who want to relive the golden age of UO.`,
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
     },
     {
        name: 'Endor Revived',
        slug: 'endor-revived',
        establishedAt: new Date("October 5, 2023"),
        shards: [
            'Endor Revived'
        ],
        logo: '/images/logos/server-endor-revived.png',
        website: 'https://www.endor-revived.com/',
        description: `Endor is a popular MMORPG based on the Ultima Online. It has a long tradition of game development and player support dating back to the early 2000s a legacy longer than many famous titles such as World of Warcraft. Experience/Level system, custom map, dozens of cities, hundreds of dungeons and quests. 5.10.2023 the shard was restarted from scratch and has been modernized with a huge update to classes, map, dungeons, systems and much more.

Endor is a classic sandbox game - you can literally do anything you want in this vast and open fantasy world. Want to be a famous dungeon conqueror? A merciless player-killer? Own a house and a boat? Or just chill in one of the taverns and chat with other players? You can do it all on Endor. Only your skill and determination will make the difference between success and failure.

Endor is unique in the Ultima Online scene for its experience and class-based system. You can choose from 13 different classes and make your own way through this beautiful and rich world. Defeat enemies, gain experience, advance to higher levels, collect better equipment and challenge stronger foes. It's a classic, time-tested RPG play style that works and doesn’t need to be changed. Each character also has a set of core skills that increase in power as you level up and can be trained by the character.

However, Endor has evolved throughout its existence, allowing it to refine its core features and expand its content to a level that rivals most modern MMORPGs.

Endor's core features are still growing, we are not done yet!

Endor offers all this and more. 5/10/2023 the shard was restarted from scratch and has been modernized with a huge update to classes, map, dungeons, systems and much more, so everyone can start on the same level. And the best part? Endor is free, with experienced staff always ready to help if you have a problem, and a community to guide you if you get lost. We must also warn you that Endor can be tough and is not for the faint of heart.

What are you waiting for, are you ready to make a history? Start playing!

The legend continues with you!`,
        
     }

     
]

// server-ai-siege-perilous.png
export const getServerSlug = (server: UOServers) => serverInfo.find(s => s.name === server)?.slug || ''
export const getServerList = () => serverInfo.map(s => s.name)
export const getServerDetailList = () => serverInfo.map(s => ({name: s.name, slug: s.slug, skills: s.skills, logo: s.logo}))
export const getServerSkills = (server: UOServers | string) => serverInfo.find(s => s.name === server)?.skills || []


export const getFileTypes = () => [
    'Razor Script (Outlands)',
    'Razor Script (Community Edition)',
    'Razor Enhanced (Python)',
    'Razor Enhanced (C#)',
    'LUA',
    'BASH',
    'CMD',
    'XML',
]

export const SimpleServerSchema = z
	.string({ required_error: 'Server is required' });
    
// TODO: actually validate the server based on valid options lol
// export const ServerSchema = z
//     .object({server: SimpleServerSchema})
// 	.superRefine(({ server }, ctx) => {

//         if (!serverInfo.some(s => s.name === server)) {
//             ctx.addIssue({
//                 path: ['server'],
//                 code: 'custom',
//                 message: 'Invalid server selection',
//             })
//         }


// 	})
